import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center",
      color: "blue",
      display: "inline-flex"
    },
    icon: {
      height: "55px",
      marginRight: "17px",
      width: "40px"
    },
    lineOne: {
      fontWeight: "bold"
    },
    root: {
      background: "#8be7ec",
      borderColor: "#8be7ec",
      display: "inline-block",
      marginBottom: 20,
      width: "100%"
    }
  },
  { name: "StoreOrderReminderCard" }
);

// export interface StoreOrderReminderCardProps {

// }

const StoreOrderReminderCard: React.SFC = props => {
  const classes = useStyles(props);
  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <InfoOutlinedIcon className={classes.icon} />
        <div>
          <div className={classes.lineOne}>
            {" "}
            <span>
              After preparation, kindly just hand the order to the runner/rider.
              Wala na pong babayaran ang runner/rider, ibigay na lamang ang
              order.
            </span>
          </div>
          <div>
            {" "}
            <span>
              The payment will be processed by SM from the customer into your
              brand's nominated bank account. SM na ang mag proproseso ng
              payment papunta sa inyong bank account.
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreOrderReminderCard;
